import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "@/config/router";
import { theme } from "@/config/theme";
import { QueryLoadingLayer } from "@/components/common/QueryLoadingLayer";
import { ErrorProvider, useError } from "@/contexts/ErrorContext";
import { setGlobalErrorHandler } from "@/helpers/axiosInstance";
import React from "react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorProvider>
        <ErrorHandlerInitializer />
        <QueryLoadingLayer />
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </ErrorProvider>
    </QueryClientProvider>
  );
};

function ErrorHandlerInitializer() {
  const { showError } = useError();
  React.useEffect(() => {
    setGlobalErrorHandler(showError);
  }, [showError]);
  return null;
}

export default App;
